import React from 'react'

const WhatsApp = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <defs>
                        <linearGradient
                            id="a"
                            x1={256}
                            x2={256}
                            y1="488.97"
                            y2="23.47"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0} stopColor="#00d02d" />
                            <stop offset=".25" stopColor="#10d93a" />
                            <stop offset=".75" stopColor="#3af15d" />
                            <stop offset={1} stopColor="#51fe71" />
                        </linearGradient>
                    </defs>
                    <rect
                        width="465.5"
                        height="465.5"
                        x="23.25"
                        y="23.47"
                        className="cls-1"
                        rx="120.17"
                        ry="120.17"
                        style={{ fill: "url(#a)" }}
                        fill=""
                    />
                    <path
                        d="M256 87.13a165.54 165.54 0 0 0-143.23 248.49l-22.5 86.13 87.55-23.19A165.52 165.52 0 1 0 256 87.13ZM353.34 350a137.75 137.75 0 0 1-171.76 18.51L130.72 382l13-49.68A137.67 137.67 0 1 1 353.34 350Z"
                        className=""
                        fill="#ffffff"
                        opacity={1}
                        data-original="#000000"
                    />
                    <path
                        d="M338.94 296a46.42 46.42 0 0 1-.69 8.12 48.74 48.74 0 0 1-2 8C334.2 317.91 323 325 323 325a42.59 42.59 0 0 1-27 7 59.82 59.82 0 0 1-6.65-1.06c-3.72-.83-5.53-1.36-5.53-1.36-1.8-.53-6.47-2-6.47-2-4.67-1.46-5.72-1.74-5.72-1.74a116.7 116.7 0 0 1-20.53-8.37c-15.13-8.22-31.61-22.95-31.61-22.95a186.89 186.89 0 0 1-26.32-28.86 121.83 121.83 0 0 1-10.6-19.47c-.4-1-2.37-5.49-2.37-5.49-2-4.48-2.7-6.21-2.7-6.21-.72-1.74-2-5.34-2-5.34a54.33 54.33 0 0 1-1.79-6.49 49.79 49.79 0 0 1-.74-6c-.58-10.52 4.65-21.59 4.65-21.59 5.75-11.9 11.33-14.62 11.33-14.62a57.22 57.22 0 0 1 7.7-2.83 39.54 39.54 0 0 1 8-1.6 6.63 6.63 0 0 1 2.42.21c2.1.57 6.55 8.35 6.55 8.35 1.38 2.1 3.77 6 3.77 6 2.4 3.88 4.41 7 4.41 7 2 3.15 3.88 5.91 3.88 5.91.37.44 2.16 2.75 2.16 2.75a34.09 34.09 0 0 1 2.68 3.92 8.27 8.27 0 0 1 1 3.21c.12 2.29-2.94 5.9-2.94 5.9a64.22 64.22 0 0 1-6.74 6.68 77.76 77.76 0 0 0-6.75 6.46c-3.08 3.38-3 5.44-3 5.44a9.74 9.74 0 0 0 .71 2.54c.66 1.51 1.11 2.29 1.11 2.29.44.77 1.75 2.65 1.75 2.65 1.31 1.88 1.43 2.1 1.43 2.1a135.36 135.36 0 0 0 21.39 25.75c11.83 10.58 28 18.39 28 18.39.24.1 2.25 1.19 2.25 1.19 2 1.1 2.83 1.45 2.83 1.45.82.36 2.4.84 2.4.84a8.06 8.06 0 0 0 2.6.43c2.06-.11 5.08-3.55 5.08-3.55a79.28 79.28 0 0 0 5.66-7.43 65.05 65.05 0 0 1 5.89-7.43c3.25-3.45 5.54-3.58 5.54-3.58a8.7 8.7 0 0 1 3.3.62 40 40 0 0 1 4.19 2.23c2.5 1.52 3 1.84 3 1.84 3 1.56 6.32 3.2 6.32 3.2 3.36 1.65 7.48 3.6 7.48 3.6 4.12 1.95 6.36 3.08 6.36 3.08 8.23 3.56 9 5.58 9 5.58a8.3 8.3 0 0 1 .56 2.36Z"
                        className=""
                        fill="#ffffff"
                        opacity={1}
                        data-original="#000000"
                    />
                </g>
            </svg>

        </>
    )
}

export default WhatsApp